import { Component, Inject } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationBar } from 'src/services/notification.service';

@Component({
  selector: 'app-workspace-create-dialog',
  templateUrl: './workspace-create-dialog.component.html',
  styleUrl: './workspace-create-dialog.component.scss'
})
export class WorkspaceCreateDialogComponent {
  workspaceGroup = new FormGroup({
    nameControl: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(16)]),
  });
  isProcessing = false;
  notificationBar: NotificationBar;
  // workspaceID = ""

  constructor(public dialogRef: MatDialogRef<WorkspaceCreateDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private fireFunctions: AngularFireFunctions, private snackBar: MatSnackBar, private fireAuth: AngularFireAuth) {
    this.notificationBar = new NotificationBar(snackBar);
  }

  ngOnInit() {
    this.dialogRef.backdropClick().subscribe( x => {
      this.dialogRef.close(false);
    });
    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === "Escape") {
        this.dialogRef.close(false);
      }
    });
  }

  async create() {
    this.isProcessing = true;
    var name = this.workspaceGroup.controls.nameControl.value;
    var uid = (await (this.fireAuth.currentUser)).uid;
    this.fireFunctions.httpsCallable("esportsms-createWorkspace")({name, uid}).subscribe( res => {
      this.isProcessing = false;
      this.notificationBar.show("Workspace created!");
      this.dialogRef.close(res);
    }, err => {
      this.isProcessing = false;
      if (err.code == "functions/permission-denied") {
        this.notificationBar.show("Missing permission!");
      }
      else {
        this.notificationBar.showUnknownError();
      }
    });
  }

  getErrorName() {
    if (this.workspaceGroup.controls.nameControl.hasError('maxlength')) {
      return 'Maximum 16 characters'
    }
    else return this.workspaceGroup.controls.nameControl.hasError('minlength') ? 'Use 2 characters or more' : '';
  } 
}
